export default __webpack_public_path__ + "static/media/frontdoor.aa059151.jpg";